import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { ForeignActivitiesDirectModel } from './types';
import { foreignActivitiesDirectItemValidator } from './validators/item';

const foreignActivitiesDirectValidator: ValidateJSModel<ForeignActivitiesDirectModel> = {
  HasInterests: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasInterests?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignActivitiesDirectItemValidator },
      };
    }

    return {};
  },
};
export default foreignActivitiesDirectValidator;
